import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';

class Message {
}
var messageType;
(function (messageType) {
    messageType["Error"] = "E";
    messageType["Warning"] = "W";
    messageType["Success"] = "S";
    messageType["Information"] = "I";
    messageType["Exception"] = "X";
})(messageType || (messageType = {}));

class MessageService {
    constructor() {
        this.messages = [];
        this.messageSource = new BehaviorSubject([]);
        this.msgTypePattern = 'SWEIX';
        this.msgStore = [];
        this.langu = 'EN';
    }
    getObservable() {
        return this.messageSource.asObservable();
    }
    /**
     * Tell the message service what is the message storage(array) and language
     * msgStore: an Array that stores all messages in a session
     * {string} the language preferred in the session
     */
    setMessageStore(msgStore, langu) {
        this.msgStore = msgStore;
        this.langu = langu;
    }
    /**
     * Add a message object into a message list
     * {Message} message
     */
    add(message) {
        if (!message)
            return;
        this.messages.push(message);
        this.messageSource.next(this.messages);
    }
    /**
     * Report only one message at a time
     */
    report(message) {
        if (!message)
            return;
        this.messages = [];
        this.messages.push(message);
        this.messageSource.next(this.messages);
    }
    /**
     * Report a message at a time based on msgCat, msgName, msgType
     * It is usually used for messages generated in client side(Angular)
     * msgCat
     * msgName
     * msgType
     * {string} args
     */
    reportMessage(msgCat, msgName, msgType, ...args) {
        this.report(this.generateMessage(msgCat, msgName, msgType, ...args));
    }
    /**
     * Add a message to a list based on msgCat, msgName, msgType
     * It is usually used for messages generated in client side(Angular)
     * msgCat
     * msgName
     * msgType
     * {string} args
     */
    addMessage(msgCat, msgName, msgType, ...args) {
        this.add(this.generateMessage(msgCat, msgName, msgType, ...args));
    }
    /**
     * Clear all the messages in the container(show in the UI)
     */
    clearMessages() {
        this.messages = [];
        this.messageSource.next(this.messages);
    }
    /**
     * Remove a message from the list by its index(position)
     * idx
     */
    removeMessage(idx) {
        this.messages.splice(idx, 1);
    }
    /**
     * Generate a message object based on msgCat, msgName, msgType from the message store array
     * The message store array is generated in client side.
     * It supports variable parameters for the placeholders' replacement in short and long texts.
     */
    generateMessage(msgCat, msgName, msgType, ...args) {
        this.checkInputParameters(msgCat, msgName, msgType);
        let message = this.msgStore.find(function (message) {
            return message.msgCat === msgCat && message.msgName === msgName;
        });
        if (message) {
            let msg = new Message();
            msg.msgCat = message.msgCat;
            msg.msgName = message.msgName;
            msg.msgType = msgType;
            msg.msgShortText = this.replacePlaceholdersInShortText(message.msgText[this.langu] ? message.msgText[this.langu].shortText : message.msgText['EN'].shortText, args);
            msg.msgLongText = this.replacePlaceholdersInLongText(message.msgText[this.langu] ? message.msgText[this.langu].longText : message.msgText['EN'].longText, args);
            return msg;
        }
        else {
            return null;
        }
    }
    checkInputParameters(msgCat, msgName, msgType) {
        if (!msgCat)
            throw new Error('Message Category is missing!');
        if (!msgName)
            throw new Error('Message Name is missing');
        if (this.msgTypePattern.search(msgType) === -1)
            throw new Error('Message Type is invalid!');
    }
    replacePlaceholdersInShortText(text, args) {
        let i = -1;
        return text.replace(/%s/g, function () {
            i++;
            return ((args[i] === undefined) ? '' : args[i]);
        });
    }
    replacePlaceholdersInLongText(text, args) {
        return text.replace(/(%s)([1-99])/g, function (match, p1, p2) {
            let i = -1 + parseInt(p2);
            return ((args[i] === undefined) ? '' : args[i]);
        });
    }
}
/** @nocollapse */ MessageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.9", ngImport: i0, type: MessageService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ MessageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.9", ngImport: i0, type: MessageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.9", ngImport: i0, type: MessageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class MessageComponent {
    constructor(messageService) {
        this.messageService = messageService;
    }
    ngOnInit() {
        this.messageService.getObservable().subscribe(messages => this.messages = messages);
    }
    getMessageDisplayClass(msgType) {
        switch (msgType) {
            case messageType.Error: {
                return 'alert-danger';
            }
            case messageType.Warning: {
                return 'alert-warning';
            }
            case messageType.Success: {
                return 'alert-success';
            }
            case messageType.Information: {
                return 'alert-info';
            }
            case messageType.Exception: {
                return 'alert-danger';
            }
            default: {
                return 'alert-secondary';
            }
        }
    }
    getCardDisplayClass(msgType) {
        switch (msgType) {
            case messageType.Error: {
                return 'card-danger';
            }
            case messageType.Warning: {
                return 'card-warning';
            }
            case messageType.Success: {
                return 'card-success';
            }
            case messageType.Information: {
                return 'card-info';
            }
            case messageType.Exception: {
                return 'card-danger';
            }
            default: {
                return '';
            }
        }
    }
    removeMessage(idx) {
        this.messageService.removeMessage(idx);
    }
    toggleShowLongText(idx) {
        if (this.messages[idx].showLongText) {
            this.messages[idx].showLongText = false;
        }
        else {
            this.messages.forEach(message => message.showLongText = false);
            this.messages[idx].showLongText = true;
        }
        return false; // To forbid page refresh when clicking the link
    }
}
/** @nocollapse */ MessageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.9", ngImport: i0, type: MessageComponent, deps: [{ token: MessageService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ MessageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.9", type: MessageComponent, selector: "dk-message", ngImport: i0, template: "<div *ngFor=\"let message of messages; index as idx;\" class=\"dk-message\">\n  <div class=\"card\" [ngClass]=\"getCardDisplayClass(message.msgType)\">\n    <div class=\"alert card-header\" [ngClass]=\"getMessageDisplayClass(message.msgType)\" role=\"alert\" >\n      <a class=\"alert-link \" (click)=\"toggleShowLongText(idx)\" href=\"#\" >\n        {{message.msgShortText}}\n      </a>\n      <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\" (click)=\"removeMessage(idx)\">\n        <span aria-hidden=\"true\">&times;</span>\n      </button>\n    </div>\n\n    <div *ngIf=\"message.msgLongText\" class=\"collapse\" [ngClass]=\"{'show': message.showLongText}\">\n      <div class=\"card-body\" [innerHtml]=\"message.msgLongText\">\n      </div>\n    </div>\n  </div>\n</div>\n\n\n\n\n", styles: [".card{position:relative;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card-header{padding:.75rem 1.25rem;margin-bottom:0;color:inherit;background-color:#00000008;border-bottom:1px solid rgba(0,0,0,.125)}.card-header:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.alert-danger{color:#721c24;background-color:#f8d7da;border-color:#f5c6cb}.alert-danger .alert-link{color:#491217}.alert-warning{color:#856404;background-color:#fff3cd;border-color:#ffeeba}.alert-warning .alert-link{color:#533f03}.alert-success{color:#155724;background-color:#d4edda;border-color:#c3e6cb}.alert-success .alert-link{color:#0b2e13}.alert-info{color:#0c5460;background-color:#d1ecf1;border-color:#bee5eb}.alert-info .alert-link{color:#062c33}.alert{position:relative;padding:.75rem 1.25rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-link{font-weight:700}.close:not(:disabled):not(.disabled){cursor:pointer}.collapse:not(.show){display:none}.card-body{flex:1 1 auto;padding:1.25rem}.close{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}button.close{padding:0;background-color:transparent;border:0;-webkit-appearance:none;-moz-appearance:none;appearance:none}a{color:#007bff;background-color:transparent}button,select{text-transform:none}button,input{overflow:visible}button,input,optgroup,select,textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button{border-radius:0}.alert.card-header{margin-bottom:0}.dk-message{margin-bottom:.5rem}\n"], directives: [{ type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.9", ngImport: i0, type: MessageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dk-message', template: "<div *ngFor=\"let message of messages; index as idx;\" class=\"dk-message\">\n  <div class=\"card\" [ngClass]=\"getCardDisplayClass(message.msgType)\">\n    <div class=\"alert card-header\" [ngClass]=\"getMessageDisplayClass(message.msgType)\" role=\"alert\" >\n      <a class=\"alert-link \" (click)=\"toggleShowLongText(idx)\" href=\"#\" >\n        {{message.msgShortText}}\n      </a>\n      <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\" (click)=\"removeMessage(idx)\">\n        <span aria-hidden=\"true\">&times;</span>\n      </button>\n    </div>\n\n    <div *ngIf=\"message.msgLongText\" class=\"collapse\" [ngClass]=\"{'show': message.showLongText}\">\n      <div class=\"card-body\" [innerHtml]=\"message.msgLongText\">\n      </div>\n    </div>\n  </div>\n</div>\n\n\n\n\n", styles: [".card{position:relative;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card-header{padding:.75rem 1.25rem;margin-bottom:0;color:inherit;background-color:#00000008;border-bottom:1px solid rgba(0,0,0,.125)}.card-header:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.alert-danger{color:#721c24;background-color:#f8d7da;border-color:#f5c6cb}.alert-danger .alert-link{color:#491217}.alert-warning{color:#856404;background-color:#fff3cd;border-color:#ffeeba}.alert-warning .alert-link{color:#533f03}.alert-success{color:#155724;background-color:#d4edda;border-color:#c3e6cb}.alert-success .alert-link{color:#0b2e13}.alert-info{color:#0c5460;background-color:#d1ecf1;border-color:#bee5eb}.alert-info .alert-link{color:#062c33}.alert{position:relative;padding:.75rem 1.25rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-link{font-weight:700}.close:not(:disabled):not(.disabled){cursor:pointer}.collapse:not(.show){display:none}.card-body{flex:1 1 auto;padding:1.25rem}.close{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}button.close{padding:0;background-color:transparent;border:0;-webkit-appearance:none;-moz-appearance:none;appearance:none}a{color:#007bff;background-color:transparent}button,select{text-transform:none}button,input{overflow:visible}button,input,optgroup,select,textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button{border-radius:0}.alert.card-header{margin-bottom:0}.dk-message{margin-bottom:.5rem}\n"] }]
        }], ctorParameters: function () { return [{ type: MessageService }]; } });

class MessageModule {
}
/** @nocollapse */ MessageModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.9", ngImport: i0, type: MessageModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ MessageModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.9", ngImport: i0, type: MessageModule, declarations: [MessageComponent], imports: [CommonModule], exports: [MessageComponent] });
/** @nocollapse */ MessageModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.9", ngImport: i0, type: MessageModule, imports: [[
            CommonModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.9", ngImport: i0, type: MessageModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [MessageComponent],
                    exports: [MessageComponent]
                }]
        }] });

/*
 * Public API Surface of message
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Message, MessageComponent, MessageModule, MessageService, messageType };
